import { jsonInit } from '@shigo-ui/api-client';

import { createShigoApiClient, type ShigoApiConfig } from '../../../lib/shigo-api-client';
import {
  serializeSupplyListFilter,
  serializeTailoredSupplyListFilter,
  supplyAppSchema,
  supplyDomainSchema,
  supplyPageSchema,
  supplyReferenceListSchema,
  tailoredSupplyDetailSchema,
  tailoredSupplySchema,
  type SupplyAppPayload,
  type SupplyDomainPayload,
  type SupplyListFilter,
  type TailoredSupplyPayload,
} from './model';

type SupplyClientOptions = { config: ShigoApiConfig; accessToken: string; fetcher?: typeof fetch };

export function createSupplyClient({ config, accessToken, fetcher }: SupplyClientOptions) {
  const api = createShigoApiClient(config, accessToken, fetcher);
  return {
    listApps: (filter: SupplyListFilter) =>
      api.request({
        path: `/apps?${serializeSupplyListFilter(filter)}`,
        schema: supplyPageSchema(supplyAppSchema),
      }),
    getApp: (id: string) =>
      api.request({ path: `/apps/${encodeURIComponent(id)}`, schema: supplyAppSchema }),
    createApp: (payload: SupplyAppPayload) =>
      api.request({
        path: '/apps/inventory',
        schema: supplyAppSchema,
        init: jsonInit('POST', payload),
      }),
    updateApp: (id: string, payload: SupplyAppPayload) =>
      api.request({
        path: `/apps/inventory/${encodeURIComponent(id)}`,
        schema: supplyAppSchema,
        init: jsonInit('PUT', payload),
      }),
    listDomains: (filter: SupplyListFilter) =>
      api.request({
        path: `/domains?${serializeSupplyListFilter(filter)}`,
        schema: supplyPageSchema(supplyDomainSchema),
      }),
    getDomain: (id: string) =>
      api.request({ path: `/domains/${encodeURIComponent(id)}`, schema: supplyDomainSchema }),
    createDomain: (payload: SupplyDomainPayload) =>
      api.request({
        path: '/domains',
        schema: supplyDomainSchema,
        init: jsonInit('POST', payload),
      }),
    updateDomain: (id: string, payload: SupplyDomainPayload) =>
      api.request({
        path: `/domains/${encodeURIComponent(id)}`,
        schema: supplyDomainSchema,
        init: jsonInit('PUT', payload),
      }),
    listPlatforms: () =>
      api.request({ path: '/apps/platforms', schema: supplyReferenceListSchema }),
    listIabCategories: () =>
      api.request({ path: '/iab-categories', schema: supplyReferenceListSchema }),
    listTailoredSupplies: (filter: SupplyListFilter) =>
      api.request({
        path: `/tailored-supply?${serializeTailoredSupplyListFilter(filter)}`,
        schema: supplyPageSchema(tailoredSupplySchema),
      }),
    getTailoredSupply: (id: string) =>
      api.request({
        path: `/tailored-supply/${encodeURIComponent(id)}`,
        schema: tailoredSupplyDetailSchema,
      }),
    createTailoredSupply: (payload: TailoredSupplyPayload) =>
      api.request({
        path: '/tailored-supply',
        schema: tailoredSupplyDetailSchema,
        init: jsonInit('POST', payload),
      }),
    updateTailoredSupply: (id: string, payload: TailoredSupplyPayload) =>
      api.request({
        path: `/tailored-supply/${encodeURIComponent(id)}`,
        schema: tailoredSupplyDetailSchema,
        init: jsonInit('PUT', payload),
      }),
  };
}
